import { FAILED, PENDING, SUCCEEDED } from '../../../../../../types/loadingStatus'
import { OutreachButton } from '../../../../..'
import { defineMessages, useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { ButtonGroup } from '@homebotapp/hb-react-component-catalog'
import useViewport from '../../../../../../hooks/useViewport'
import { OUTREACH_BUTTON } from '../../../../../../constants/messages'
import { useTrackingContext } from '../../../../../../providers/tracking'
import { sendPmiRemovalDMRequest } from '../../../../../../store/slices/pmi'
import { selectPmiDMRequestedStatus } from '../../../../../../store/slices/pmi'
import { PmiProvidedModuleLearnMoreButton } from '../../../PmiProvidedModuleLearnMoreButton'
import { HOMEOWNER_DIGEST_PMI_MODULE } from '../../../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

import styles from './CanRemovePmiDetailsFooter.module.scss'
import { CUSTOMER_MESSAGES } from '../../../../../../constants/customerMessages'

export const MSG = defineMessages({
  ask: {
    id: 'Pmi.pmiCtaButtonSection.askAboutPMIRemoval',
    defaultMessage: 'Ask about removal'
  }
})

export const CanRemovePmiDetailsFooter = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { isMediumOrAbove } = useViewport()
  const { trackingClient } = useTrackingContext()
  const requestStatus = useSelector(selectPmiDMRequestedStatus)

  const handleClick = () => {
    trackingClient?.pmiRemoved()
    dispatch(
      sendPmiRemovalDMRequest({
        message: intl.formatMessage(CUSTOMER_MESSAGES.MORTGAGE_INSURANCE.secondaryMessage),
        trackingClient
      })
    )
  }

  return (
    <ButtonGroup gap={1} width='100%' display='flex' orientation={isMediumOrAbove ? 'horizontal' : 'vertical'}>
      <OutreachButton
        buttonMessage={MSG.ask}
        handleClick={handleClick}
        className={styles.outreach}
        colorScheme='primary'
        failure={requestStatus === FAILED}
        requested={requestStatus === PENDING}
        success={requestStatus === SUCCEEDED}
        resultMessage={
          requestStatus === SUCCEEDED
            ? intl.formatMessage(OUTREACH_BUTTON.success)
            : intl.formatMessage(OUTREACH_BUTTON.failure)
        }
        tracking={{
          guid: '8rccizo8Br4L3Z5yKarh3v',
          ui_context: HOMEOWNER_DIGEST_PMI_MODULE,
          descriptor: MSG.ask.defaultMessage
        }}
      />
      <PmiProvidedModuleLearnMoreButton flex='1 1 auto' />
    </ButtonGroup>
  )
}
